import { z } from 'zod';

import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateArmRateChangeNotificationSideEffect = BaseLoanIdSideEffect.extend({
  type: z.literal('generateArmRateChangeNotification'),
});
export type GenerateArmRateChangeNotificationSideEffect = z.infer<typeof GenerateArmRateChangeNotificationSideEffect>;
